module.exports = __webpack_public_path__ + "img/ico-list.ac4c864c.svg";